import { copyFor } from '@/lib/messages';
import type { Locale } from '@/lib/locale';

const BASE = 'https://budsrewards.com';

/**
 * The hosted documents. Exported so the acceptance step links to exactly the
 * pages the footer does — two sources would eventually disagree, and the
 * whole point of that step is that the user saw *these*.
 */
export const LEGAL_URLS = {
  notice: `${BASE}/site-notice.html`,
  privacy: `${BASE}/privacy-statement.html`,
  terms: `${BASE}/terms-of-use.html`,
} as const;

export function LegalLinks({ locale }: { locale: Locale }) {
  const copy = copyFor(locale);
  const links = [
    { href: LEGAL_URLS.notice, label: copy.legalNotice },
    { href: LEGAL_URLS.privacy, label: copy.legalPrivacy },
    { href: LEGAL_URLS.terms, label: copy.legalTerms },
  ];

  return (
    <nav className="flex flex-wrap justify-start gap-x-2 text-sm text-buds-muted">
      {links.map((link) => (
        <a
          key={link.href}
          href={link.href}
          target="_blank"
          rel="noreferrer noopener"
          // Padding, not font size, is what makes a link tappable: these were
          // 16px-tall text-xs targets against the project's own 44px rule.
          className="focus-ring inline-flex min-h-11 items-center px-2 hover:text-buds-dark hover:underline"
        >
          {link.label}
        </a>
      ))}
    </nav>
  );
}
